<template>
  <layout width="420">
    <template slot="header">
      Create objects from devices
    </template>

    <template #no-offset>
      <v-tabs v-model="tab">
        <v-tabs-slider />
        <pre />
        <v-tab
          v-for="(item, index) in items"
          :key="item.name"
          :disabled="
            (!data.general.type || !data.general.objectType) && index !== 0
          "
        >
          {{ item.name }}
        </v-tab>
      </v-tabs>
      <v-divider />
      <v-tabs-items v-model="tab" style="overflow-y: auto">
        <v-tab-item v-for="item in items" :key="item.name" class="px-4">
          <component
            :is="item.component"
            :data="data"
            :tab="tab"
            @update-form="setData"
          />
        </v-tab-item>
      </v-tabs-items>
    </template>
    <template slot="footer">
      <v-spacer />
      <v-btn text color="text-primary" @click="close">
        Cancel
      </v-btn>
      <v-btn
        text
        color="primary"
        depressed
        :loading="false"
        :disabled="!data.general.type || !data.general.objectType"
        @click="submit"
      >
        Create
      </v-btn>
    </template>
  </layout>
</template>

<script>
import { reactive, ref, toRefs } from '@vue/composition-api';
import { useLazyQuery, useMutation } from '@vue/apollo-composable';
import { usePopup } from '@/compositions/popup';

import { useAuth } from '@/modules/auth/api';

import Layout from '@/components/popup/PopupLayoutDefault';
import GeneralTab from '@/modules/objects/ui/objects-from-devices/general';

import linkedObjectScheme from '@/modules/linked-objects/api/linked-object.graphql';
import schemas from '@/modules/objects/api/object-from-devices.graphql';

export default {
  name: 'ObjectCreate',
  components: {
    LocationTab: () =>
      import('@/modules/objects/ui/objects-from-devices/location'),
    ItemsTab: () => import('@/modules/objects/ui/objects-from-devices/items'),
    StatesTab: () => import('@/modules/objects/ui/objects-from-devices/states'),
    GeneralTab,
    Layout
  },
  props: {
    centerMap: { type: Array, default: () => [] }
  },
  setup(props, { emit }) {
    const popup = usePopup();

    const state = reactive({
      data: {
        centerMap: props.centerMap,
        general: {},
        states: [],
        location: [],
        monitoringItems: [],
        geoItems: []
      }
    });

    const { mutate: createControlExecution } = useMutation(
      linkedObjectScheme.createControlExecution
    );

    const objectsCount = useLazyQuery(
      schemas.countDevices,
      {},
      {
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-only'
      }
    );

    const { getUserProfileId } = useAuth();

    const tab = ref(null);
    const items = [
      { name: 'general', component: 'GeneralTab' },
      { name: 'states', component: 'StatesTab' },
      { name: 'items', component: 'ItemsTab' },
      { name: 'location', component: 'LocationTab' }
    ];

    const preSubmit = title => {
      popup.openConfirm({
        component: () => import('@/components/popup/PopupConfirmAction.vue'),
        props: {
          title,
          onConfirm: () => {
            getUserProfileId().then(profileId => {
              createControlExecution({
                input: {
                  objectId: profileId,
                  name: 'AddMonitorObjects',
                  params: {
                    JWT: localStorage.getItem('authToken'),
                    PARAMETERS: JSON.stringify(state.data)
                  }
                }
              })
                .catch(e => {
                  throw new Error(e);
                })
                .then(() => {
                  close();
                });
            });
          }
        }
      });
    };

    const setData = async obj => {
      if (obj.key === 'items') {
        state.data.monitoringItems = obj.data.monitoringItems;
        state.data.geoItems = obj.data.geoItems;
      } else {
        state.data[obj.key] = obj.data;
      }
    };

    const submit = async () => {
      console.info(JSON.stringify(state.data), 'payload');
      objectsCount.variables.value.schemaId = state.data.general.objectType;
      objectsCount.variables.value.name = state.data.general.objectNameContains;
      if (!objectsCount.result.value) {
        objectsCount.load();
        objectsCount.onResult(({ data }) => {
          preSubmit(`Create ${data.objectsConnection.totalCount} object(s)?`);
        });
      } else {
        objectsCount.restart();
        preSubmit(
          `Create ${objectsCount.result.value.objectsConnection.totalCount} object(s)?`
        );
      }
    };

    const close = async () => {
      emit('close');
    };

    return {
      ...toRefs(state),
      items,
      tab,
      close,
      submit,
      preSubmit,
      setData
    };
  }
};
</script>
